// Witcore Suite - Version 1.0.0
// Copyright(c) 2024 Witcore LLC. All rights reserved.

import React from 'react';
import BriefField from './BriefField.js';
import AvatarField from './AvatarField.js';
import ComplexField from './ComplexField.js';

const Brief = function ({ fieldsDisposition, fieldsSize, hideLabels, fields }) {
  switch (fieldsDisposition) {
    case 'center': {
      return (
        <div className="d-flex justify-content-center pt-2">
          {fields.map((field, index) =>
            <div key={'field-' + index} className={(index === 0 ? 'ps-2' : 'ps-5') + ' ' + (index === (fields.length - 1) ? 'pe-2' : 'pe-5')}>
              <BriefField size={fieldsSize} field={field} />
            </div>
          )}
        </div>
      );
    }
    case 'end': {
      return (
        <div className="d-flex justify-content-end pt-2">
          {fields.map((field, index) =>
            <div key={'field-' + index} className={(index === 0 ? 'ps-2' : 'ps-5') + ' ' + (index === (fields.length - 1) ? 'pe-2' : 'pe-5')}>
              <BriefField size={fieldsSize} field={field} />
            </div>
          )}
        </div>
      );
    }
    case 'spaces-between': {
      return (
        <div className="d-flex justify-content-between pt-2">
          {fields.map((field, index) =>
            <div key={'field-' + index} className={(index === 0 ? 'ps-2' : 'ps-5') + ' ' + (index === (fields.length - 1) ? 'pe-2' : 'pe-5')}>
              <BriefField size={fieldsSize} field={field} />
            </div>
          )}
        </div>
      );
    }
    case 'spaces-around': {
      return (
        <div className="d-flex justify-content-around pt-2">
          {fields.map((field, index) =>
            <div key={'field-' + index} className={(index === 0 ? 'ps-2' : 'ps-5') + ' ' + (index === (fields.length - 1) ? 'pe-2' : 'pe-5')}>
              <BriefField size={fieldsSize} field={field} />
            </div>
          )}
        </div>
      );
    }
    case 'floating': {
      return (
        <div className="d-flex flex-wrap pt-2">
          {fields.map((field, index) =>
            <div key={'field-' + index} className="pb-3" style={{ width: '280px' }}>
              <BriefField size={fieldsSize} field={field} />
            </div>
          )}
        </div>
      );
    }
    case 'table': {
      return (
        <div className="table-responsive">
          <table className="table">
            <tbody>
              {fields.map((field, index) =>
                (fieldsSize === 'large' ?
                  <tr key={'field-' + index} className="fs-2">
                    <td className="w-auto fw-bold" style={{ minWidth: 180 }}>
                      {field.label}
                    </td>
                    <td className="w-100">
                      <div className="d-flex align-items-center">
                        <AvatarField size="xl" field={field} />
                        <ComplexField field={field} />
                      </div>
                    </td>
                  </tr> :
                  <tr key={'field-' + index}>
                    <td className="w-auto fw-bold" style={{ minWidth: 180 }}>
                      {field.label}
                    </td>
                    <td className="w-100">
                      <div className="d-flex align-items-center">
                        <AvatarField field={field} />
                        <ComplexField field={field} />
                      </div>
                    </td>
                  </tr>
                )
              )}
            </tbody>
          </table>
        </div>
      );
    }
    default: {
      return (
        <div className="d-flex pt-2">
          {fields.map((field, index) =>
            <div key={'field-' + index} className={(index === 0 ? 'ps-2' : 'ps-5') + ' ' + (index === (fields.length - 1) ? 'pe-2' : 'pe-5')}>
              <BriefField size={fieldsSize} field={field} />
            </div>
          )}
        </div>
      );
    }
  }
}

export default Brief;
